<template>
  <SlideYUpTransition :duration="animationDuration">
    <div
      ref="modal"
      class="modal fade"
      @click.self="dismissable ? closeModal() : () => {}"
      :class="[
        { 'show d-block': show },
        { 'd-none': !show },
        { 'modal-mini': type === 'mini' },
        containerClasses,
      ]"
      v-show="show"
      tabindex="-1"
      role="dialog"
      :aria-hidden="!show">
      <div
        class="modal-dialog"
        role="document"
        :class="[
          { 'modal-notice': type === 'notice' },
          { 'modal-dialog-centered': centered },
          modalClasses
      ]">
        <div
          class="modal-content"
          :class="[
            gradient ? `bg-gradient-${gradient}` : '',
            modalContentClasses
        ]">
          <div
            class="modal-header"
            :class="[headerClasses]"
            v-if="$slots.header">
            <slot name="header" />
            <slot name="close-button">
              <button
                type="button"
                class="close"
                v-if="showClose"
                @click="closeModal"
                data-dismiss="modal"
                aria-label="Close">
                <i class="tim-icons icon-simple-remove" />
              </button>
            </slot>
          </div>

          <div
            v-if="$slots.default"
            class="modal-body"
            :class="bodyClasses">
            <slot />
          </div>

          <div
            class="modal-footer"
            :class="footerClasses"
            v-if="$slots.footer">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </div>
  </SlideYUpTransition>
</template>
<script>
import { SlideYUpTransition } from 'vue2-transitions';

export default {
  name: 'Modal',
  components: {
    SlideYUpTransition,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    dismissable: {
      type: Boolean,
      default: false,
      description: 'Whether modal should be dismissed by clicking outside modal window on backdrop',
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    centered: {
      type: Boolean,
      default: false,
    },
    appendToBody: {
      type: Boolean,
      default: true,
      description: 'Whether modal should be appended to document body',
    },
    scrollToBottom: {
      type: Boolean,
      default: false,
      description: "Whether modal should scroll to it's bottom automatically",
    },
    type: {
      type: String,
      default: '',
      validator(value) {
        const acceptedValues = ['', 'notice', 'mini'];
        return acceptedValues.indexOf(value) !== -1;
      },
      description: 'Modal type (notice|mini|"") ',
    },
    containerClasses: {
      type: [Object, String],
      default: '',
      description: 'Modal container css classes',
    },
    modalClasses: {
      type: [Object, String],
      default: '',
      description: 'Modal dialog css classes',
    },
    modalContentClasses: {
      type: [Object, String],
      default: '',
      description: 'Modal dialog content css classes',
    },
    gradient: {
      type: String,
      default: '',
      description: 'Modal gradient type (danger, primary etc)',
    },
    headerClasses: {
      type: [Object, String],
      default: '',
      description: 'Modal Header css classes',
    },
    bodyClasses: {
      type: [Object, String],
      default: '',
      description: 'Modal Body css classes',
    },
    footerClasses: {
      type: [Object, String],
      default: '',
      description: 'Modal Footer css classes',
    },
    animationDuration: {
      type: Number,
      default: 500,
      description: 'Modal transition duration',
    },
  },
  methods: {
    closeModal() {
      this.$emit('update:show', false);
      this.$emit('close');
    },
    scrollModalToBottom() {
      if (!this.scrollToBottom) return;
      const elm = this.$refs.modal;
      elm.scrollTop = elm.scrollHeight - elm.clientHeight;
    },
    toggleDocumentBodyClasses(show) {
      const documentClasses = document.body.classList;
      if (show) {
        documentClasses.add('modal-open');
        this.$nextTick(this.scrollModalToBottom);
      } else {
        const numModals = document.getElementsByClassName('modal show').length;
        // only remove class if this is the only modal open
        if (numModals <= 1) {
          documentClasses.remove('modal-open');
        }
      }
    },
  },
  mounted() {
    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    }
    this.toggleDocumentBodyClasses(this.show);
  },
  destroyed() {
    if (this.appendToBody && this.$el) {
      if (this.$el.parentNode) this.$el.parentNode.removeChild(this.$el);
      this.toggleDocumentBodyClasses(false);
    }
  },
  watch: {
    show(val) {
      this.toggleDocumentBodyClasses(val);
    },
  },
};
</script>
<style>
.modal.show {
  background-color: rgba(0, 0, 0, 0.3);
}
</style>
